const contact = {
  email: "anton.rost16@gmail.com",
  linkedin: "https://www.linkedin.com/in/anton-rost",
  phone: "+49 (1520) 3228208",
  phoneHref: "+4915203228208",
  website: "https://www.antonrost.de",
  fullName: "Anton - Johannes Rost",
  street: "Rheinstraße 12",
  postalCode: "55116",
  city: "Mainz",
  vatId: "DE 453 422 598"
};

const shared = {
  de: {
    nav: { home: "Start", projects: "Projekte", capabilities: "Kompetenzen", archive: "Archiv", resume: "Lebenslauf", contact: "Kontakt" },
    footer: "QA Engineering Portfolio von Anton Rost",
    illustrative: "Berufliche Fallstudie",
    anonymized: "Für das Portfolio anonymisiert",
    sampleData: "Beispielansicht",
    common: { viewProject: "Fallstudie ansehen", allProjects: "Alle Fallstudien", contact: "Kontakt aufnehmen", archive: "Zum Archiv", back: "Zurück zu den Fallstudien", technologies: "Technologien", outcome: "Ergebnis", updated: "Aktualisiert", contents: "Inhalt", sampleOnly: "Alle gezeigten Daten und Ansichten wurden für das Portfolio erstellt." },
    home: {
      seo: { title: "Anton Rost – QA Engineer & Test Automation", description: "Portfolio von Anton Rost mit Fallstudien zu Selenium- und TestNG-Automatisierung sowie QA-Reporting mit n8n und Grafana." },
      eyebrow: "QA Engineering Portfolio",
      title: "QA für Webapps.",
      intro: "Ich entwickle Browser-Tests und QA-Reporting für wichtige Geschäftsabläufe.",
      availability: "",
      primary: "Fallstudien ansehen",
      secondary: "Lebenslauf öffnen",
      capabilitiesTitle: "Woran ich arbeite",
      capabilitiesSubhead: "Tests, CI und Reporting",
      capabilities: [
        ["Browser-Testautomatisierung", "Wichtige Abläufe wiederholbar prüfen."],
        ["Testdaten & Integration", "Rollen, Daten und abhängige Zustände abdecken."],
        ["CI & Fehlerdiagnose", "Fehler mit brauchbarem Kontext hinterlassen."],
        ["QA-Reporting", "Getrennte Qualitätssignale lesbar zusammenführen."]
      ],
      projectsTitle: "Zwei Fallstudien aus meiner QA-Arbeit",
      projectsSubhead: "Berufliche Arbeit, fürs Portfolio anonymisiert",
      approachTitle: "Wie ich an QA herangehe",
      approach: [
        ["Geschäftsrisiko zuerst", "Kritische Abläufe bestimmen die Reihenfolge."],
        ["Fehler nachvollziehbar machen", "Ein roter Lauf braucht verwertbaren Kontext."],
        ["Testbarkeit früh mitdenken", "Daten und beobachtbare Zustände rechtzeitig klären."]
      ]
    },
    projectsPage: {
      seo: { title: "QA-Fallstudien – Anton Rost", description: "Zwei anonymisierte berufliche Fallstudien zu Selenium-Testautomatisierung und Quality Operations Monitoring." },
      eyebrow: "Berufliche QA-Arbeit",
      title: "Zwei Fallstudien.",
      intro: "Browser-Regression für einen Webshop und gemeinsames QA-Reporting für vier getrennte Quellen.",
      note: "Beide Arbeiten wurden für dieses Portfolio anonymisiert und neu visualisiert."
    },
    capabilitiesPage: {
      seo: { title: "QA-Kompetenzen – Anton Rost", description: "Erfahrung von Anton Rost in Teststrategie, Selenium-Automatisierung, TestNG, CI, visuellen Tests und QA-Reporting." },
      eyebrow: "Kompetenzen",
      title: "Mein QA-Werkzeugkasten.",
      intro: "Webtests, CI und QA-Reporting.",
      items: [
        ["Risikobasiertes Testdesign", "Wichtige Abläufe und Fehlerpfade priorisieren.", "Risiken · Abdeckung · negative Pfade"],
        ["Selenium-Testautomatisierung", "Datengetriebene Browser-Tests entwickeln und pflegen.", "Java · Selenium WebDriver · TestNG · Maven · Apache POI"],
        ["Testdaten & Integration", "Rollen, Daten und abhängige Zustände prüfen.", "Fixtures · Authentifizierung · Integrationszustände"],
        ["CI & Fehlerdiagnose", "Läufe und Diagnoseartefakte in CI einbinden.", "GitLab CI · Allure · XML · Screenshots · Logs"],
        ["Visuelle Regression", "UI-Änderungen gezielt vergleichen.", "Percy · Reviews · responsive Ansichten"],
        ["Quality Operations Reporting", "Getrennte QA-Signale gemeinsam anzeigen.", "n8n · Grafana · PostgreSQL"]
      ],
      workflowTitle: "Mein Ablauf",
      workflow: [
        ["01 · Verstehen", "Ziel, Grenzen und Risiken klären."],
        ["02 · Priorisieren", "Die sinnvolle Abdeckung festlegen."],
        ["03 · Umsetzen", "Tests stabil in CI bringen."],
        ["04 · Auswerten", "Fehler mit Kontext ausgeben."]
      ]
    },
    contact: {
      seo: { title: "Kontakt – Anton Rost QA Engineering", description: "Kontakt zu Anton Rost für QA-Engineering-Rollen, Selenium-Automatisierung und QA-Reporting." },
      title: "Kontakt",
      subhead: "Schreib mir gern.",
      intro: "Für QA-Rollen, Selenium-Automatisierung, Reporting oder einen fachlichen Austausch.",
      name: "Name",
      email: "E-Mail",
      subject: "Betreff",
      message: "Nachricht",
      submit: "Nachricht senden",
      success: "Danke – deine Nachricht wurde gesendet.",
      error: "Die Nachricht konnte nicht gesendet werden. Schreib mir bitte direkt per E-Mail.",
      direct: "Direkter Kontakt"
    },
    archive: {
      seo: { title: "Archiv – Anton Rost", description: "Ältere UI/UX-Arbeiten von Anton Rost." },
      title: "Archiv",
      subhead: "Frühere Arbeiten aus UI/UX und Webentwicklung",
      intro: "Frühere UI/UX-Arbeiten aus meinem Portfolio.",
      items: [
        { title: "Filmmaker Site", description: "Konzept und UI/UX-Arbeit für die Portfolio-Website eines Filmemachers.", slug: "filmmaker-site" },
        { title: "3D Art Site", description: "Portfolio-Konzept für studentische 3D-Arbeiten.", slug: "3d-art-site" }
      ],
      details: {
        filmmaker: { title: "Filmmaker Site", description: "Recherche, Wireframes und Designsystem für ein Filmemacher-Portfolio." },
        art: { title: "3D Art Site", description: "Personas, Mockups und Portfolio-Konzept für studentische 3D-Arbeiten." }
      }
    },
    legal: {
      privacyTitle: "Datenschutz",
      privacyEyebrow: "Hinweise zum Kontaktformular",
      privacyController: "Verantwortlicher",
      privacy: "Ich nutze die Angaben aus dem Kontaktformular nur, um auf deine Nachricht zu antworten. Beim Absenden werden sie an den dafür eingerichteten E-Mail-Dienst übertragen. Für externe Links gelten die Datenschutzbestimmungen der jeweiligen Anbieter.",
      legalTitle: "Impressum",
      legalEyebrow: "Angaben gemäß § 5 DDG",
      legalIntro: "Anbieter und verantwortlich für diese Website:",
      providerTitle: "Anbieter",
      addressTitle: "Anschrift",
      contactTitle: "Kontakt",
      websiteLabel: "Website",
      linkedinLabel: "LinkedIn",
      vatTitle: "Umsatzsteuer",
      vatLabel: "Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG"
    }
  },
  en: {
    nav: { home: "Home", projects: "Projects", capabilities: "Capabilities", archive: "Archive", resume: "Résumé", contact: "Contact" },
    footer: "QA Engineering Portfolio by Anton Rost",
    illustrative: "Professional case study",
    anonymized: "Anonymized for this portfolio",
    sampleData: "Example view",
    common: { viewProject: "View case study", allProjects: "All case studies", contact: "Get in touch", archive: "View archive", back: "Back to case studies", technologies: "Technologies", outcome: "Result", updated: "Updated", contents: "Contents", sampleOnly: "All data and interfaces shown were created for this portfolio." },
    home: {
      seo: { title: "Anton Rost – QA Engineer & Test Automation", description: "Anton Rost's portfolio with case studies on Selenium and TestNG automation and QA reporting with n8n and Grafana." },
      eyebrow: "QA Engineering Portfolio",
      title: "QA for web applications.",
      intro: "I build browser tests and QA reporting for important business journeys.",
      availability: "",
      primary: "View case studies",
      secondary: "View résumé",
      capabilitiesTitle: "What I work on",
      capabilitiesSubhead: "Testing, CI, and reporting",
      capabilities: [
        ["Browser test automation", "Repeatable checks for important user journeys."],
        ["Test data & integration", "Roles, data, and dependent states."],
        ["CI & failure diagnosis", "Useful context for failed runs."],
        ["QA reporting", "Separate quality signals in one readable view."]
      ],
      projectsTitle: "Two case studies from my QA work",
      projectsSubhead: "Professional work, anonymized for this portfolio",
      approachTitle: "How I approach QA",
      approach: [
        ["Business risk first", "Critical journeys set the order."],
        ["Make failures explainable", "A failed run needs useful context."],
        ["Consider testability early", "Clarify data and observable states in good time."]
      ]
    },
    projectsPage: {
      seo: { title: "QA case studies – Anton Rost", description: "Two anonymized professional case studies on Selenium test automation and quality operations monitoring." },
      eyebrow: "Professional QA work",
      title: "Two case studies.",
      intro: "Webshop browser regression and shared QA reporting across four separate sources.",
      note: "Both projects were anonymized and newly visualized for this portfolio."
    },
    capabilitiesPage: {
      seo: { title: "QA capabilities – Anton Rost", description: "Anton Rost's experience in test strategy, Selenium automation, TestNG, CI, visual testing, and QA reporting." },
      eyebrow: "Capabilities",
      title: "My QA toolkit.",
      intro: "Web testing, CI, and QA reporting.",
      items: [
        ["Risk-based test design", "Prioritize important flows and failure paths.", "Risks · coverage · negative paths"],
        ["Selenium test automation", "Build and maintain data-driven browser checks.", "Java · Selenium WebDriver · TestNG · Maven · Apache POI"],
        ["Test data & integration", "Test roles, data, and dependent states.", "Fixtures · authentication · integration states"],
        ["CI & failure diagnosis", "Connect runs and diagnostics to CI.", "GitLab CI · Allure · XML · screenshots · logs"],
        ["Visual regression", "Compare UI changes where they matter.", "Percy · reviews · responsive views"],
        ["Quality Operations reporting", "Show separate QA signals in one view.", "n8n · Grafana · PostgreSQL"]
      ],
      workflowTitle: "My process",
      workflow: [
        ["01 · Understand", "Clarify goals, boundaries, and risks."],
        ["02 · Prioritize", "Choose useful coverage."],
        ["03 · Implement", "Run stable checks in CI."],
        ["04 · Review", "Report failures with context."]
      ]
    },
    contact: {
      seo: { title: "Contact – Anton Rost QA Engineering", description: "Contact Anton Rost about QA engineering roles, Selenium automation, and QA reporting." },
      title: "Contact",
      subhead: "Feel free to write.",
      intro: "For QA roles, Selenium automation, reporting, or a technical exchange.",
      name: "Name",
      email: "Email",
      subject: "Subject",
      message: "Message",
      submit: "Send message",
      success: "Thanks, your message has been sent.",
      error: "The message could not be sent. Please email me directly instead.",
      direct: "Direct contact"
    },
    archive: {
      seo: { title: "Archive – Anton Rost", description: "Earlier UI/UX work by Anton Rost." },
      title: "Archive",
      subhead: "Earlier UI/UX and web-development work",
      intro: "Earlier UI/UX work from my portfolio.",
      items: [
        { title: "Filmmaker Site", description: "Concept and UI/UX work for a filmmaker's portfolio website.", slug: "filmmaker-site" },
        { title: "3D Art Site", description: "A portfolio concept for student 3D work.", slug: "3d-art-site" }
      ],
      details: {
        filmmaker: { title: "Filmmaker Site", description: "Research, wireframes, and a design system for a filmmaker portfolio." },
        art: { title: "3D Art Site", description: "Personas, mockups, and a portfolio concept for student 3D work." }
      }
    },
    legal: {
      privacyTitle: "Privacy",
      privacyEyebrow: "Contact-form privacy information",
      privacyController: "Controller",
      privacy: "I use the details submitted through the contact form only to reply to your message. When you submit the form, they are sent to the configured email service. External websites have their own privacy policies.",
      legalTitle: "Legal notice",
      legalEyebrow: "Information pursuant to Section 5 DDG",
      legalIntro: "Provider of and person responsible for this website:",
      providerTitle: "Provider",
      addressTitle: "Business address",
      contactTitle: "Contact",
      websiteLabel: "Website",
      linkedinLabel: "LinkedIn",
      vatTitle: "VAT",
      vatLabel: "VAT identification number pursuant to Section 27a UStG"
    }
  }
};

export function getCopy(locale) { return shared[locale] || shared.de; }
export { contact };
